/* tslint:disable */

export function debugLog(...params: any[]) {
    console.log(...params);
}
